/*
 * Ryan O'Dowd
 * 2024-04-14
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: {
      flex: 1,
      width: '100%',
      minHeight: 'calc(100vh - 56px - 35px - 114px)', // @TODO: header and footer heights; check mobile; don't hardcode; no idea what the 114px is
      justifyContent: 'center',
      alignItems: 'flex-start',
      margin: 'auto',
      // @TODO: marginBottom: 64,
    },
    sectionWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
  };
};

export default getStyles;
